/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql, StaticQuery } from "gatsby";

const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
  }
`;

const SEO = ({
  description,
  lang,
  meta,
  title,
  pathname,
  image,
  breadcrumbs,
}) => (
  <StaticQuery
    query={`${query}`}
    render={({ site }) => {
      const metaDescription = description || site.siteMetadata.description;

      const finalMeta = {
        author: site.siteMetadata.author,
        description: metaDescription,
        "theme-color": site.siteMetadata.themeColor,
        "twitter:card": "summary",
        // "twitter:site": site.siteMetadata.twitter,
        // "twitter:creator": site.siteMetadata.twitter,
        "og:title": title,
        "og:description": metaDescription,
        "og:type": "website",
        "og:locale": lang,
        "og:url": `${site.siteMetadata.siteUrl}${pathname}`,
        ...meta,
      };

      if (image) {
        finalMeta["og:image"] = `https://swire.com${image}`;
        finalMeta["og:image:alt"] = metaDescription;
      }

      const metaArray = [];

      for (const name in finalMeta) {
        metaArray.push({
          name,
          content: finalMeta[name],
        });
      }

      const breadcrumbElements = [
        {
          "@type": "ListItem",
          item: {
            "@id": site.siteMetadata.siteUrl,
            name: site.siteMetadata.title,
          },
          position: 1,
        },
      ];

      for (let i = 0; i < breadcrumbs.length; i++) {
        const breadcrumb = breadcrumbs[i];
        breadcrumbElements.push({
          "@type": "ListItem",
          item: {
            "@id": `${site.siteMetadata.siteUrl}${breadcrumb.pathname}`,
            name: breadcrumb.name,
          },
          position: i + 2,
        });
      }

      return (
        <Helmet
          htmlAttributes={{
            lang,
          }}
          title={title}
          // titleTemplate={`%s | ${site.siteMetadata.title}`}
          titleTemplate={`%s`}
          meta={metaArray}
        >
          {breadcrumbElements.length > 1 ? (
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                description: "Breadcrumbs list",
                name: "Breadcrumbs",
                itemListElement: breadcrumbElements,
              })}
            </script>
          ) : null}
        </Helmet>
      );
    }}
  />
);

SEO.defaultProps = {
  lang: `en`,
  meta: {},
  description: ``,
  breadcrumbs: [],
  pathname: "",
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.object,
  title: PropTypes.string,
  pathname: PropTypes.string,
  image: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
